import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "438",
  height: "438",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M395.88 323.28V202.72H219V25.84H98.44q-23.76 0-39.6 16.72-16.72 15.84-16.72 39.6v120.56H219V379.6h120.56q23.76 0 39.6-16.72 16.72-15.84 16.72-39.6m15.84-241.12v241.12q0 29.92-21.12 51.04t-51.04 21.12H98.44q-29.92 0-51.04-21.12t-21.12-51.04V82.16q0-29.92 21.12-51.04T98.44 10h241.12q29.92 0 51.04 21.12t21.12 51.04"
    }, null, -1)
  ])))
}
export default { render: render }